import { AgencyBean } from 'common/api/api'
import React from 'react'

import { DictionarySelector, DictionarySelectorProps, enumToLabelValue } from './DictionarySelector'

import FeatureAccessEnum = AgencyBean.FeatureAccessEnum

export const FeatureAccessSelector: React.FC<DictionarySelectorProps> = (props) => (
  <DictionarySelector
    {...props}
    cacheKey="featureAccess"
    mode="multiple"
    loader={() => enumToLabelValue(FeatureAccessEnum)}
  />
)
